import { render, staticRenderFns } from "./sales-statistics.vue?vue&type=template&id=5e2ad8ea"
import script from "./sales-statistics.vue?vue&type=script&lang=js"
export * from "./sales-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports